var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMemberActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7528\u6237\u9009\u4E2D\u540E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7528\\u6237\\u9009\\u4E2D\\u540E",
    fill: "#52C41A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,9 L9,9 C11.209139,9 13,10.790861 13,13 L13,15.3766696 L13,15.3766696 L7,15.3766696 C5.8954305,15.3766696 5,14.4812391 5,13.3766696 L5,11 C5,9.8954305 5.8954305,9 7,9 Z",
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7528\\u6237-(1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00090602,8.22547496 C9.26862628,8.22547496 11.1136435,6.38045775 11.1136435,4.11273748 C11.1136435,3.77711488 10.8415171,3.50680262 10.5077086,3.50680262 C10.1739002,3.50680262 9.90177378,3.77892906 9.90177378,4.11273748 C9.90177378,5.7128409 8.60100944,7.01360525 7.00090602,7.01360525 C5.40080259,7.01360525 4.10003825,5.7128409 4.10003825,4.11273748 C4.10003825,2.51263406 5.40080259,1.21186971 7.00090602,1.21186971 C7.41272402,1.21186971 7.81002861,1.29532182 8.18193473,1.46222603 C8.48671634,1.59828925 8.84592323,1.46222603 8.98198644,1.15563025 C9.11804966,0.850848645 8.98198644,0.491641754 8.67539066,0.355578538 C8.14565121,0.11973563 7.58325658,0 6.99909184,0 C4.73137157,0 2.88635436,1.84501721 2.88635436,4.11273748 C2.88635436,6.38045775 4.73318575,8.22547496 7.00090602,8.22547496 L7.00090602,8.22547496 Z M8.87676422,8.94026039 L5.12504781,8.94026039 C2.29856127,8.94026039 0,11.2388217 0,14.0653082 L0,15.072176 C0,15.4077986 0.272126432,15.6781109 0.605934856,15.6781109 C0.93974328,15.6781109 1.21186971,15.4059844 1.21186971,15.072176 L1.21186971,14.0653082 C1.21186971,11.9082527 2.96799229,10.1521301 5.12504781,10.1521301 L8.87495005,10.1521301 C11.0320056,10.1521301 12.7881281,11.9082527 12.7881281,14.0653082 L12.7881281,15.072176 C12.7881281,15.4077986 13.0602546,15.6781109 13.394063,15.6781109 C13.7296856,15.6781109 14,15.4059844 14,15.072176 L14,14.0653082 C14.001812,11.2388217 11.7032508,8.94026039 8.87676422,8.94026039 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.26681211,2.30218962 C9.26681211,2.5186693 9.38230262,2.71870478 9.56977953,2.82694463 C9.75725643,2.93518447 9.9882375,2.93518447 10.1757144,2.82694463 C10.3631913,2.71870478 10.4786818,2.5186693 10.4786818,2.30218962 C10.4786818,2.08570994 10.3631913,1.88567445 10.1757144,1.77743461 C9.9882375,1.66919476 9.75725643,1.66919476 9.56977953,1.77743461 C9.38230262,1.88567445 9.26681211,2.08570994 9.26681211,2.30218962 Z",
    id: "\\u8DEF\\u5F84"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMemberActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/member_active.4f3f4439281927da3e5bf7027875faa6.svg";